<section class="content">
  <article>
    <!-- start header -->
    <h2 class="heading-underline">
      <div class="header-content">
        @if (isDocMergeEnabled) {
          <span class="tab-navigation">
            <span (click)="selectAwesomeDocsTab()" class="tab-link awesomedocs-tab" [class.active]="workflowType === Workflow.SimpleDocx">
              AwesomeDocs
            </span>
            <span class="tab-count">({{ awesomeDocsCount }})</span>
            <ng-container>
              <span (click)="selectDocMergeTab()" class="tab-link docmerge-tab" [class.active]="workflowType === Workflow.DocumentMerge">
                DocMerge
              </span>
              <span class="tab-count">({{ docMergeCount }})</span>
            </ng-container>
          </span>
        } @else {
          <span>Templates</span>
        }
        @if (dataSource?.data.length !== 0 && !listIsLoading()) {
          <span class="clear-input">
            <input
              class="search-profiles"
              type="text"
              (keyup)="filterColumnData($event)"
              placeholder="Search (Ctrl+Shift+F)..."
              #searchInput
            />
            <mat-icon
              class="clear-icon"
              [fontIcon]="searchInput.value ? 'close' : 'search'"
              (click)="clearInput(searchInput, true)"
              [ngStyle]="searchInput.value ? { cursor: 'pointer' } : { cursor: 'default' }"
              [matTooltip]="searchInput.value ? 'Clear' : ''"
              matTooltipShowDelay="500"
              #clearSearch
            ></mat-icon>
          </span>
        }
      </div>
      <span class="sub-info">
        <span id="createTemplate" (click)="createNewTemplate()" [matTooltip]="'Create a new template (Alt+N)'" matTooltipShowDelay="500">
          Create new template<mat-icon fontIcon="add"></mat-icon>
        </span>
        <span id="settings" (click)="openAdv2ConfigDialog()" [matTooltip]="'AwesomeDocs Admin Settings'" matTooltipShowDelay="500"
          ><mat-icon fontIcon="settings"></mat-icon
        ></span>
      </span>
    </h2>
    <!-- end header -->
    <!-- start button group - move to component -->
    @if (entityTypesUsed.length === 0) {
      <app-skeleton [style]="'tab-filter-buttons'" [flex]="true" [gap]="12" [count]="5"></app-skeleton>
    }
    <!-- Up the count if we start seeing lots more -->
    <app-entity-toggle-group
      [entityTypesUsed]="entityTypesUsed"
      [currentEntityFilter]="entityFilter()"
      [totalOverride]="currentWorkflowTemplateCount"
      (onFilterChange)="filterEntities($event)"
      [value]="entityFilter()"
    ></app-entity-toggle-group>
    <!-- end button group -->
    <!-- start template table component - move to component -->
    <section class="scrollable-container" cdkScrollable>
      <table mat-table [dataSource]="dataSource" class="table-striped row-highlight" matSort matSortActive="name" matSortDirection="asc">
        <ng-container matColumnDef="label">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by entity">
            {{ recordTerm }}
          </th>
          <td mat-cell *matCellDef="let element" [matTooltip]="element.tooltip" matTooltipShowDelay="500">
            {{ element.label }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="attachment">
          <th mat-header-cell *matHeaderCellDef aria-label="Attachment"></th>
          <td mat-cell *matCellDef="let element">
            @if (templateHasAttachmentSection(element)) {
              <mat-icon
                fontIcon="attach_file"
                class="attachment-icon"
                matTooltip="This template has file attachment enabled"
                matTooltipShowDelay="500"
              ></mat-icon>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="isPublic">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by visibility">Visibility</th>
          <td mat-cell *matCellDef="let element">
            {{ element.isPublic ? 'Published' : 'Unpublished' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dateCreated">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by dateCreated">Date Created</th>
          <td mat-cell *matCellDef="let element">
            {{ element.dateCreated | date: 'medium' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="createdBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by createdBy">Created By</th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdBy }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dateModified">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by dateModified">Date Modified</th>
          <td mat-cell *matCellDef="let element">
            {{ element.dateModified | date: 'medium' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="modifiedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by modifiedBy">Modified By</th>
          <td mat-cell *matCellDef="let element">
            {{ element.modifiedBy }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <aside>
              <mat-icon
                fontIcon="content_copy"
                class="copy-icon"
                matTooltip="Copy '{{ element.name }}'"
                matTooltipShowDelay="500"
                (click)="$event.stopPropagation(); copyWorkflowConfig(element)"
              ></mat-icon>
            </aside>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
        <tr style="cursor: pointer" mat-row *matRowDef="let row; columns: displayedColumns()" (click)="openWorkflowConfigDialog(row)"></tr>
      </table>
      @if ((dataSource?.data?.length === 0 || noResults) && !listIsLoading()) {
        <div class="no-results">
          @if (dataSource?.data?.length === 0) {
            <span>NO TEMPLATES, ADD ONE BELOW</span>
          }
          @if (noResults && dataSource?.data?.length !== 0) {
            <span>NO TEMPLATES FOUND</span>
          }
        </div>
      }
      @if (listIsLoading()) {
        <app-skeleton [style]="'big-row-table'" [count]="3"></app-skeleton>
      }
    </section>
    <!-- end template table component -->
    <section class="footer-btns">
      <button theme="nav" (click)="createNewTemplate()">Create new Template<mat-icon fontIcon="add">add</mat-icon></button>
    </section>
  </article>
</section>
